import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import colors from '../../../../../../../../../../styles/theme/foundation/colors';
import PINSAISparkIcon from '../../../../../../../../../PINSAISparkIcon';

const StartingTrialModal = props => (
  <Box
    mt={8}
    py={8}
  >
    <Text
      color={colors.greyScale['900']}
      fontSize="30px"
      fontWeight="600"
      lineHeight="38px"
    >
      Your Request is Confirmed!
    </Text>
    <PINSAISparkIcon mx="auto" my={4} w="23px" />
    <Text color={colors.greyScale['900']} textStyle="bodySm600">
      Our sales team will be in touch shortly to help get you started with your free trial.
    </Text>
  </Box>
);

StartingTrialModal.propTypes = {};

export default StartingTrialModal;
